import type { Layer, TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'
import { DimStyleName } from './constant'

/**
 * DXF 两线角度标注（DIMENSION + AcDb2LineAngularDimension）实体。
 */
export default class AngularDimension extends DatabaseObject {
  /** 所属图层 */
  layer!: Layer
  /** 线型名称，默认跟随图层 */
  lineType: string = 'ByLayer'
  /** 线宽，单位百分之毫米；-1 表示跟随图层 */
  lineWidth: number = -1
  /** 真彩色 RGB 整数，undefined 表示不写入 */
  trueColor: number | undefined

  constructor(
    public line1Start: { x: number; y: number },
    public line1End: { x: number; y: number },
    public line2Start: { x: number; y: number },
    public line2End: { x: number; y: number },
    public arcPoint: { x: number; y: number },
    public textPosition: { x: number; y: number },
    public text: string,
    public hasUserDefinedTextPosition: boolean = false,
    public blockName?: string
  ) {
    super('AcDbEntity')
  }

  /**
   * 写入 DIMENSION 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager) {
    manager.push(0, 'DIMENSION')
    super.tags(manager)
    manager.push(8, this.layer.name)
    manager.push(6, this.lineType)
    manager.push(62, 256)
    manager.push(370, this.lineWidth)
    if (this.trueColor !== undefined) {
      manager.push(420, this.trueColor)
    }

    manager.push(100, 'AcDbDimension')
    manager.push(280, 0)
    if (this.blockName) {
      manager.push(2, this.blockName)
    }
    manager.push(3, DimStyleName)
    manager.point(this.line2Start.x, this.line2Start.y)
    manager.push(11, this.textPosition.x)
    manager.push(21, this.textPosition.y)
    manager.push(31, 0)
    manager.push(70, 2 | (this.blockName ? 32 : 0) | (this.hasUserDefinedTextPosition ? 128 : 0))
    manager.push(71, 5)
    manager.push(1, this.text || '<>')

    manager.push(100, 'AcDb2LineAngularDimension')
    manager.push(13, this.line1Start.x)
    manager.push(23, this.line1Start.y)
    manager.push(33, 0)
    manager.push(14, this.line1End.x)
    manager.push(24, this.line1End.y)
    manager.push(34, 0)
    manager.push(15, this.line2End.x)
    manager.push(25, this.line2End.y)
    manager.push(35, 0)
    manager.push(16, this.arcPoint.x)
    manager.push(26, this.arcPoint.y)
    manager.push(36, 0)
  }
}
